import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: '#0A2463',
            light: '#d1dfff',
            dark: '#051333'
        },
        secondary: {
            main: '#63b4ff',
            light: '#9ed0ff',
            dark: '#00529e'
        },
        error: {
            main: '#e85151'
        },
        info: {
            main: '#ffffff'
        }
    }
});

export default theme;

export const secondaryTheme = createTheme({
    palette: {
        primary: {
            main: "#536878"
        }
    }
})

export const resaltTheme = createTheme({
    palette: {
        primary: {
            main: '#39444f'
        },
        secondary: {
            main: "#829bae"
        }
    }
});

export const whiteTheme = createTheme({
    palette: {
        primary: {
            main: '#ffffff'
        }
    }
});